import { getCalendarDaysUntilDate } from '@noths/polaris-client-utils';
import type { ParsedUrlQuery } from 'querystring';

const toArray = (value: string | string[] | undefined): string[] =>
  value === undefined ? [] : Array.isArray(value) ? value : [value];

const getFirstValue = (value: string | string[] | undefined): string | undefined =>
  Array.isArray(value) ? value[0] : value;

const mergeDeliveryDays = (
  existing: string | string[] | undefined,
  newValue: string,
): string | string[] => {
  const existingValues = toArray(existing);

  if (existingValues.length === 0) {
    return newValue;
  }

  if (existingValues.includes(newValue)) {
    return existing!;
  }

  return [...existingValues, newValue];
};

const DELIVERY_DAYS_PARAM = 'dd';

export const adaptPageURLToStore = (initialQuery: ParsedUrlQuery): ParsedUrlQuery => {
  const deliveryByDateStr = getFirstValue(initialQuery.delivery_by_date);

  if (!deliveryByDateStr) {
    return initialQuery;
  }

  const { delivery_by_date, ...restOfInitialQuery } = initialQuery;

  const isValidDate = !isNaN(new Date(deliveryByDateStr).getTime());

  if (!isValidDate) {
    return restOfInitialQuery;
  }

  const daysUntilDate = getCalendarDaysUntilDate(deliveryByDateStr);

  if (daysUntilDate <= 0) {
    return restOfInitialQuery;
  }

  return {
    ...restOfInitialQuery,
    [DELIVERY_DAYS_PARAM]: mergeDeliveryDays(
      restOfInitialQuery[DELIVERY_DAYS_PARAM],
      `-${daysUntilDate}`,
    ),
  };
};
